import styled from '@emotion/styled'
import { css } from '@emotion/react'
import { Text } from 'theme-ui'

import { WithTheme } from './../../../setup/index'
import media from '../../../common/MediaQueries'
import { transition } from './../../../common/Mixins'

const FormMessageStyled = styled.div<WithTheme>`
  ${transition};
  position: relative;
  margin: auto;
  overflow-y: auto;
  max-height: 80%;
  max-width: 90%;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0rem 0.1875rem 0.375rem 0rem rgba(0, 0, 0, 0.16);
  padding: 32px 1rem;
  @media ${media.phone} {
    max-width: 80%;
  }
  @media ${media.tablet} {
    max-width: 49.625rem;
    padding: 6.25rem 7.75rem 3.125rem;
  }
`

const FormMessageIconStyled = styled.div`
  display: flex;
  justify-content: center;
  width: 5rem;
  height: 3.75rem;
  margin: 0 auto 1.375rem;
  svg {
    width: 100%;
    height: 100%;
  }
  @media ${media.phone} {
    width: 6.25rem;
    height: 5.125rem;
    margin-bottom: 2.75rem;
  }
`

const FormMessageHeadingStyled = styled(Text)<WithTheme>`
  font-size: 1.5rem;
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  text-align: center;
  margin-bottom: 1.5rem;

  @media ${media.phone} {
    font-size: 1.875rem;
  }
`

const FormMessageDescriptionStyled = styled(Text)`
  font-size: 1.125rem;
  font-weight: 500;
  text-align: center;

  @media ${media.phone} {
    font-size: 1.5625rem;
  }
`

const FormMessageFooterStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 14rem;
  margin: 2.375rem auto 0;
`

const FormMessageButtonStyled = styled.div`
  margin-bottom: 0.5rem;
`

const FormMessageCaptionStyled = styled(Text)`
  font-size: 0.625rem;
  text-align: center;
`

const FormMessageCloseStyled = styled.div<WithTheme>`
  ${transition}
  position: absolute;
  top: 1.625rem;
  width: 1rem;
  height: 1rem;
  color: ${({ theme }) => theme.colors.green};
  cursor: pointer;

  ${({ theme }) =>
    theme.direction === 'rtl'
      ? css`
          left: 1.625rem;
        `
      : css`
          right: 1.625rem;
        `}

  &:hover {
    opacity: 0.7;
  }

  svg {
    font-size: 1rem;
    width: 1rem;
    height: 1em;
  }
`

export {
  FormMessageStyled,
  FormMessageIconStyled,
  FormMessageHeadingStyled,
  FormMessageDescriptionStyled,
  FormMessageFooterStyled,
  FormMessageButtonStyled,
  FormMessageCaptionStyled,
  FormMessageCloseStyled
}
